import PlateAppearanceResult from "../../enums/PlateAppearanceResult.js";

const classifiesAsFieldersChoice = function(paResult) {
    switch (paResult) {
        case PlateAppearanceResult.FieldersChoice.key:
        // TODO - not sure how to handle SAC + FC, to keep AB correct let's exclude it for now
        //case PlateAppearanceResult.SacrificeOnFieldersChoice.key:
        //case PlateAppearanceResult.Unidentified.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsFieldersChoice;